import Cookie from 'js-cookie'

/**
 * Invalidates user's Spark BI (Jaspersoft) session.
 */
export const removeSessionCookie = () => {
    Cookie.remove('JSESSIONID')
}
